import { Component } from '@angular/core';
import { InspectionPlugin } from '../../shared/models';

import { ModalComponent } from '../../modal/modal.component';
import { BaseMenuComponent } from '../base.menu';

@Component({
    templateUrl: './filemanager.menu.html',
    standalone: false
})
export class FileManagerMenuComponent extends BaseMenuComponent {
  public fileBox: any;
  private plugin: InspectionPlugin;
  constructor(public modal: ModalComponent) {
    super(modal);
    this.modal.hasClassModal = true;
  }

  init(data: any) {
    this.fileBox = data.fileBox;
    this.plugin = data?.plugin;
  }

  public get isInOffline() {
    return !!this.plugin?.inspection?.isOffline;
  }
}
